import { getRegion } from '@/helpers/getRegion';
import type { TrackWorkRpaDesktopRequiredShown } from '@heidi/agents/contracts';
import { track as trackViaPipeline } from '@heidi/runtime/analytics';

/**
 * Shared friction event when web Work blocks a computer-use action that needs
 * the desktop RPA bridge (landing skill pick, mid-chat Approve, and invoked
 * run_computer_use_task on web without a bridge).
 *
 * Routes Datadog-only (Amplitude / PostHog / Snowplow off) — same AGE-1455
 * Datadog friction policy as ``ProjectsLandingComposer``. Snowplow schema
 * registration remains a follow-up on that original rollout.
 *
 * The vocabulary is the contracts door's; package surfaces take this emit as
 * their ``TrackWorkRpaDesktopRequiredShown`` port.
 */
export const trackWorkRpaDesktopRequiredShown: TrackWorkRpaDesktopRequiredShown = ({
  surface,
  blockedAction,
  action,
}) => {
  trackViaPipeline({
    event_name: 'work_rpa_desktop_required_shown',
    props: {
      surface,
      region: getRegion(),
      blocked_action: blockedAction,
      ...(action ? { action } : {}),
    },
    options: { amplitude: false, posthog: false, snowplow: false },
  });
};
